export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5387.2de3e0b7.jpg";